<app-fr-card>
  <h3 class="doc-title">
    <span>
      {{'Stories.documentText' | translatePipe | async}}
    </span>
  </h3>
  <div id="lightgalleryDocs" class="doc-container">
    <a *ngFor="let item of documents; let i=index" [href]="item?.cdn_path" class="doc-items" [attr.data-sub-html]="item?.detail_1">
      <img class="doc-img" [src]="item.cdn_path" [alt]="fundraiser?.title + '-' + item?.detail_1" />
    </a>
    <!-- <app-fb-share-card [sharedCounts]="sharedCounts"></app-fb-share-card> -->
  </div>
  <div class="d-none d-sm-block">
    <div class="social-share">
      <app-whatsapp-share
                          label="Share" [count]="sharedCounts?.whatsapp" [fundraiser]="fundraiser"
                          [isFundraiserEnded]="isFundraiserEnded" [basicInfo]="basicInfo" [position]="3">
      </app-whatsapp-share>
      <app-fb-share label="Share" [count]="sharedCounts?.fb" [position]="3"></app-fb-share>
      <app-donate-now *ngIf="!isFundraiserEnded" label="Contribute Now" [fundraiser]="fundraiser" [position]="3"></app-donate-now>
    </div>
  </div>
</app-fr-card>
